<div>
    <div>
        File name : {{ file }}
    </div>
    <div>
        <button mat-icon-button><mat-icon>delete</mat-icon></button>
        <button mat-icon-button><mat-icon>file_download</mat-icon></button>
    </div>
</div>